import { z } from "zod";

import { ContactGenre } from "@/lib/gql/__generated__/graphql";
import { ContactCreateInputSchema, ContactMessageItemInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { s3ObjectZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const contactCreateInputZodSchema = ContactCreateInputSchema.extend({
	contactGenre: z.nativeEnum(ContactGenre),

	reservationID: z.string().nullish(),

	hostReplyToMail: z.union([
		z.literal(""),
		z.string().trim().email("有効なメールアドレスを入力してください"),
	]),

	title: z.string().min(1, "件名を入力してください").max(100, "件名は100文字以内で入力してください"),

	message: ContactMessageItemInputSchema.extend({
		message: z
			.string()
			.min(1, "問い合わせ内容を入力してください")
			.max(3000, "問い合わせ内容は3000文字以内で入力してください"),
		relatedURLs: z.array(z.string().url().or(z.literal(""))),
		images: z
			.array(s3ObjectZodSchema)
			.nullish()
			.refine(
				(images) => {
					return !images || images.length <= 4;
				},
				{
					message: "画像は4枚以内で入力してください",
				},
			),
	}),
}).refine(
	(data) => {
		if (data.contactGenre === ContactGenre.GuestReservation) {
			return Boolean(data.reservationID);
		}

		return true;
	},
	{
		message: "予約番号を入力してください",
		path: ["reservationID"],
	},
);

export type ContactCreateInputZodSchemaType = z.infer<typeof contactCreateInputZodSchema>;
